import { Drawer, Flex, FloatButton, Layout } from "antd";
import styled from "styled-components";

const { Footer } = Layout;

export const StyledMobileMenuDrawer = styled(Drawer)`
  .ant-drawer-header {
    display: none;
  }
  .ant-drawer-body {
    padding: 0px;
    overflow: hidden;
    height: 100%;
  }
`;

export const StyledMobileMenuFloatButton = styled(FloatButton)`
  bottom: 0px;
  top: 12px;
`;

export const StyledMobileMenu = styled(Footer)`
  position: fixed;
  bottom: 0;
  padding: 0px;
  width: 100%;
  height: ${({ theme }) => `${theme.mobileMenu.height}px`};
  background: ${({ theme }) => theme.palette.background.container};
  border: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const StyledMobileMenuRow = styled(Flex)`
  height: 100%;
  padding: 0px 12px !important;
`;

export const StyledMobileMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  color: ${({ theme, active }) =>
    active === "true"
      ? theme.palette.primary.main
      : theme.palette.text.secondary};
  svg {
    margin-right: 4px;
    vertical-align: middle;
  }
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
